import { css } from 'styled-components'

export const FitToContainer = css`
  width: 100%;
  height: 100%;
`
